import { render, staticRenderFns } from "./indexButtonsNoOptions.vue?vue&type=template&id=29d7bb81"
import script from "./indexButtonsNoOptions.vue?vue&type=script&lang=js"
export * from "./indexButtonsNoOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports